import React, { useEffect, useState } from 'react'
import LoadingAbsolute from '../../LoadingAbsolute'
// import Header from '../../Header'
import IconButtonComp from '../../IconButtonComp'
import { useLocation, useNavigate } from 'react-router-dom'
import TicketSvg from '../../../assets/icons/TicketSvg'
import HistoryIconSvg from '../../../assets/icons/HistoryIconSvg'
import Header from '../../Header'
import ImageCarousel from '../../ImageCarousel'

const TheatreTicketForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)

  const [buyTicket, setBuyTicket] = useState(false)
  const [ticketHistory, setTicketHistory] = useState(false)

  useEffect(() => {
    setLoading(false)
    setBuyTicket(false)
    setTicketHistory(false)
  }, [])

  return (
    <>
      {loading ? <LoadingAbsolute text={'Yükleniyor'} /> : null}
      <div className='hide-scrollbar' style={{ marginTop: '1.5rem' }}>
        <div
          style={{
            zIndex: 99999,
            backgroundColor: '#fff',
            position: 'sticky',
            top: 0,
          }}
        >
          <Header onClick={() => navigate('/')} />
        </div>

        <ImageCarousel images={state?.basvuru_fotograflari ?? []} />

        {/* <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <img src={'https://app.yanibasimdakaratay.com/uploads/dijital_basvurular/' + state?.basvuru_fotografi} alt='' width={'90%'} height={'100%'} style={{ borderRadius: '10px' }} />
        </div> */}

        <div className='divider' />
        <>
          {state?.basvuru_aciklamasi ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginTop: '1rem',
                marginBottom: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingBottom: '0.5rem',
                fontSize: '0.9rem',
                color: '#535353',
              }}
            >
              {state?.basvuru_aciklamasi}
            </div>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                textAlign: 'center',
                marginBottom: '0.5rem',
                paddingLeft: '1rem',
                paddingRight: '1rem',
                paddingBottom: '0.5rem',
                fontSize: '0.9rem',
                color: '#535353',
              }}
            ></div>
          )}

          <IconButtonComp
            focus={buyTicket}
            icon={<TicketSvg width={'1.3rem'} height={'1.3rem'} focus={!buyTicket} />}
            onClick={() => {
              setBuyTicket(true)
              setTicketHistory(false)
              navigate('/ticket-buy-page', {
                state: {
                  basvuru_id: state.basvuru_id,
                  basvuru_sartlari_title: state.basvuru_sartlari_title,
                  basvuru_sartlari_aciklama: state.basvuru_sartlari_aciklama,
                  basvuru_fotografi: state.basvuru_fotografi,
                  basvuru_aciklamasi: state.basvuru_aciklamasi,
                  basvuru_turu: state.basvuru_turu,
                  age: state.age,
                },
              })
            }}
          >
            Bilet Al
          </IconButtonComp>
          <IconButtonComp
            focus={ticketHistory}
            icon={<HistoryIconSvg width={'1.3rem'} height={'1.3rem'} focus={ticketHistory} />}
            onClick={() => {
              setTicketHistory(true)
              setBuyTicket(false)
              navigate('/history-page', { state: 'state' })
            }}
          >
            Geçmiş Biletlerim
          </IconButtonComp>
        </>
      </div>
    </>
  )
}

export default TheatreTicketForm
